export default __webpack_public_path__ + "static/bg2-25de7894999dfea5b58086db145cc36f.jpg";